<template>
  <td>
    <label class="input-group amount-input">
      <input
        v-model="amount"
        min="0"
        type="number"
        class="form-control"
      />
      <span class="input-group-append" v-if="unit">
        <span class="input-group-text">{{unit}}</span>
      </span>
    </label>
  </td>
</template>

<script>
  const multipliers = {
    кг: 1000,
    л: 1000,
  }
  const units = {
    кг: 'г',
    л: 'мл',
  }

  export default {
    name: 'amount-input',
    props: {
      value: {},
      measure: {type: String},
    },
    data () {
      const value = parseFloat(this.value) || 0
      const multiplier = multipliers[this.measure] || 1

      return {
        amount: value * multiplier,
      }
    },
    computed: {
      multiplier () {
        return multipliers[this.measure] || 1
      },
      unit () {
        return units[this.measure] || this.measure
      },
      preparedValue () {
        return (this.amount || 0) / this.multiplier
      },
    },
    watch: {
      preparedValue (newValue) {
        this.$emit('input', newValue)
      },
      value (newValue) {
        this.amount = (parseFloat(newValue) || 0) * this.multiplier
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/recipes/amount-input.vue